module.exports = __webpack_public_path__ + "static/img/10.c5a57a30.png";